export default "__VITE_ASSET__D4S7bjXb__"